<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p44"><span><a href="#/Contents#rp44">GARLIC SOUP WITH TOASTED BREAD</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>A beaten egg is often stirred into this Mexican soup before serving.</i></span></p>
<p class="maken"><span><b>4 first-course servings</b> (about 1 cup each)</span></p>
<p class="hang"><span>4 slices French or sourdough bread</span></p>
<p class="hang"><span>Vegetable cooking spray</span></p>
<p class="hang"><span>6–8 cloves garlic, finely chopped</span></p>
<p class="hang"><span>½ teaspoon each: ground cumin, dried oregano leaves</span></p>
<p class="hang"><span>1 tablespoon olive oil</span></p>
<p class="hang"><span>2 cans (14½ ounces each) reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>Salt and cayenne pepper, to taste</span></p>
<p class="hang"><span>Chopped cilantro, as garnish</span></p>
<p class="normalt"><span><a id="page_34"></a><b>1.</b> Spray both sides of bread slices generously with cooking spray; cook in large skillet, over medium heat, until golden, about 2 minutes on each side.</span></p>
<p class="normala"><span><b>2.</b> Sauté garlic and herbs in oil in medium saucepan until lightly browned, about 3 minutes. Add broth and heat to boiling; reduce heat and simmer, covered, 5 minutes. Season to taste with salt and cayenne pepper. Place slices of bread in bottoms of soup bowls; ladle soup over and sprinkle with cilantro.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 162</span></p>
<p class="per1"><span>% calories from fat: 28</span></p>
<p class="per1"><span>Protein (g): 3.2</span></p>
<p class="per1"><span>Carbohydrate (g): 20.6</span></p>
<p class="per1"><span>Fat (g): 5</span></p>
<p class="per1"><span>Saturated fat (g): 0.7</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 202</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 1.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 1.5</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0225.vue?1ffc5438